export default {
  title: 'Feature flag',
  subtitle: 'Abilita o disabilita le funzionalità della piattaforma per {{company}}.',
  no_company: 'Seleziona un ristorante per gestire i suoi feature flag.',
  columns: {
    feature: 'Funzionalità',
    status: 'Stato',
  },
  flags: {
    paypal_standalone: {
      name: 'PayPal (diretto)',
      description:
        'Consenti a questo ristorante di accettare pagamenti PayPal direttamente sul proprio account PayPal. Attivo per impostazione predefinita per i ristoranti di partner fatturati da Foodamigos, dove la commissione di servizio al cliente viene applicata anche su questi pagamenti e la quota della piattaforma viene fatturata al partner.',
    },
    vip_free_flyers: {
      name: 'Volantini mensili gratuiti',
      description:
        'Invia automaticamente 500 volantini promozionali ogni mese a questo ristorante (impostazione predefinita: attiva per i tier VIP e Star).',
    },
    custom_store_seo: {
      name: 'SEO store personalizzato',
      description:
        'Consenti a questo ristorante di gestire le impostazioni SEO personalizzate del proprio negozio online.',
    },
    external_printer: {
      name: 'Stampante ricevute esterna',
      description:
        'Consenti a questo ristorante di collegare una stampante di rete al terminale ordini, anziché stampare con la stampante integrata del terminale.',
    },
    stripe_payment_element: {
      name: 'Checkout con Stripe Payment Element',
      description:
        "Lascia che l'account Stripe del ristorante decida quali metodi di pagamento offrire al checkout. Attivalo solo dopo aver configurato i metodi di pagamento per gli account connessi nella piattaforma Stripe.",
    },
  },
  toasts: {
    enabled: 'Funzionalità abilitata.',
    disabled: 'Funzionalità disabilitata.',
    error: 'Impossibile aggiornare la funzionalità. Riprova.',
    load_error: 'Impossibile caricare i feature flag.',
  },
};
